import { Input, TextField } from '@heroui/react';

// 贴 TDesign Input 心智的单行输入封装,收敛 TextField + Input 两层结构
export function SimpleInput({
  value,
  onChange,
  placeholder,
  className,
  type,
  isDisabled,
  isInvalid,
  'aria-label': ariaLabel,
  onEnter,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  type?: string;
  isDisabled?: boolean;
  isInvalid?: boolean;
  'aria-label'?: string;
  // 回车提交(替代 TDesign 的 onEnter)
  onEnter?: () => void;
}) {
  return (
    <TextField
      aria-label={ariaLabel ?? placeholder ?? '输入'}
      className={className}
      value={value}
      onChange={onChange}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
    >
      <Input
        fullWidth
        placeholder={placeholder}
        type={type}
        onKeyDown={
          onEnter
            ? (e) => {
                if (e.key === 'Enter') onEnter();
              }
            : undefined
        }
      />
    </TextField>
  );
}
